// Product screens showcase — 3 tabs cycling through the mocked screens
const ScreensSection = () => {
  const [tab, setTab] = React.useState(0);
  const tabs = [
    { label: "Affärer", desc: "Pipeline & inbox", screen: <LeadInbox /> },
    { label: "Offert", desc: "Kalkyl & marginal", screen: <OffertScreen /> },
    { label: "Projekt", desc: "Budget & utfall", screen: <ProjektScreen /> },
  ];

  return (
    <section className="section" id="produkt">
      <div className="container">
        <div className="section-head">
          <h2>AI som hjälper och vägleder, men inte tar över</h2>
        </div>

        <div className="tabs">
          {tabs.map((t, i) => (
            <button key={i} onClick={() => setTab(i)} className={`tab ${tab === i ? "active" : ""}`}>
              <span className="mono tab-num">0{i + 1}</span>
              <span className="tab-stack">
                <span className="tab-label">{t.label}</span>
                <span className="tab-desc">{t.desc}</span>
              </span>
            </button>
          ))}
        </div>

        <div className="screen-host" key={tab}>{tabs[tab].screen}</div>
      </div>
    </section>
  );
};

Object.assign(window, { ScreensSection });
